/**
 * Created by petr on 31.12.14.
 */
$(document).ready(function() {
    /**
     * Закрытие модального окна
     */
    if ($('.modal-window, .new-modal-window').length > 0) {
        $('div.modal-window div.close-button a, div.new-modal-window div.close-button a').on('click', function(event) {
            event.preventDefault();
            $(this).parent('div').parent('div').hide();
            $('div#modal-overlay').hide();
        });
    }

    /**
     * Закрытие модального окна при клике не на него
     */
    $(document).on('click', function(event) {
        var $modalWindow = $('.modal-window');

        if (!$(event.target).closest('.modal-window').length && !$(event.target).closest('#set-manager').length && $modalWindow.is(':visible')) {
            $modalWindow.hide();
        }
    });

    /**
     * Отправка формы по клику на кастомную "кнопку"
     */
    $(document).on('click', '.button', function() {
        if ($(this).hasClass('active') || $(this).hasClass('no-active')) {
            return false;
        }

        return $(this).addClass('active') && $(this).closest('form').submit();
    });

    /**
     * Изменяет состояние отправки статистики в CRM и в RC
     */
    $(document).on('change', '#client_sendSiteStatistic', function(e) {
        let clientId = parseInt($('body').data('client-id'));
        if (isNaN(clientId)) {
            return false;
        }

        let route = Routing.generate('api.client.change.send_site_statistic', {client: clientId});
        $.post(route, {change: e.currentTarget.checked}, function(data) {
            let $error = $('<div>').addClass('error-box');
            $('<a>').addClass('close').text('x').on('click', function () {
                $(this).closest('.error-box').remove();
            }).appendTo($error);

            if(data.success) {
                $('<h1 style="color: green;text-align: center;"></h1>').text('Успешно сохранено').appendTo($error);
            } else {
                $('<h1 style="color: firebrick;text-align: center;"></h1>').text('Ошибки при сохранении').appendTo($error);
            }

            $error.append(data.error).appendTo('body');

            setTimeout(function() {
                $('.error-box').fadeOut(1000);
            }, 2000);

            if(!data.success) {
                let clientShowSiteStatistic = document.getElementById('client_sendSiteStatistic');
                clientShowSiteStatistic.checked = !clientShowSiteStatistic.checked;
            }
        })
    });

    /**
     * Изменяет состояние показа статистики в CRM и в RC
     */
    $(document).on('change', '#client_showSiteStatistic', function(e) {
        let clientId = parseInt($('body').data('client-id'));
        if (isNaN(clientId)) {
            return false;
        }

        let route = Routing.generate('api.client.change.show_site_statistic', {client: clientId});
        $.post(route, {change: e.currentTarget.checked}, function(data) {
            let $error = $('<div>').addClass('error-box');
            $('<a>').addClass('close').text('x').on('click', function () {
                $(this).closest('.error-box').remove();
            }).appendTo($error);

            if(data.success) {
                $('<h1 style="color: green;text-align: center;"></h1>').text('Успешно сохранено').appendTo($error);
            } else {
                $('<h1 style="color: firebrick;text-align: center;"></h1>').text('Ошибки при сохранении').appendTo($error);
            }

            $error.append(data.error).appendTo('body');

            setTimeout(function() {
                $('.error-box').fadeOut(1000);
            }, 2000);

            if(!data.success) {
                let clientShowSiteStatistic = document.getElementById('client_showSiteStatistic');
                clientShowSiteStatistic.checked = !clientShowSiteStatistic.checked;
            }
        })
    });

    $(document).on('click', '#button-save', function() {
        var form = $('.fancybox-inner form'),
          $hassleModal = $('#hassle-manager'),
          $closeButton = $hassleModal.find('.close-link'),
          $proUserHassleModal = $('#pro-user-hassle-manager'),
          saveCard = function () {
              $('.error-box').remove();

              const newClient = $('body').data('new-client');
              if (newClient && window.notCheckClients === undefined) {
                  hasSimilarClients();
              }

              if (!window.hasClients) {
                  $.post($(form).attr('action'), $(form).serialize(), function(data) {

                      var $error = $('<div>').addClass('error-box');

                      $('<a>')
                        .addClass('close')
                        .text('x')
                        .on('click', function() {
                            $(this).closest('.error-box').remove();
                        })
                        .appendTo($error);

                      if (data.length > 0) {
                          $(document).trigger('save.error');

                          $('<h4>').text('Ошибки при сохранении').appendTo($error);


                      } else {
                          if(data.success) {
                              window.location.replace(Routing.generate('clients_show', {id: data.clientID}));
                          } else {
                              window.location.replace($(form).attr('action'));
                          }

                          $(document).unbind('save.success');

                          $('<h1 style="color: green;text-align: center;"></h1>').text('Успешно сохранено').appendTo($error);

                          $('.suggest').remove();

                          setTimeout(
                            function() {
                                $('.error-box').fadeOut(1000);
                            },
                            2000
                          );
                      }

                      $error.append(data).appendTo('body');
                  });
              }
          };

        if ($hassleModal.attr('data-active') === 'true') {

            $hassleModal.dialog({
                width: 660,
                minWidth: 440
            });

            $closeButton.unbind('click').on('click', function(event) {

                $hassleModal.dialog('close');
                if ($proUserHassleModal.attr('data-active') === 'true') {
                    showProUserModal(saveCard);
                } else {
                    saveCard();
                }
                event.preventDefault();

            });

        } else if ($proUserHassleModal.attr('data-active') === 'true') {
            showProUserModal(saveCard);
        } else {
            saveCard();

        }


    });

    $(document).on('click', '#anywaySave', () => {
        similarClientNotificationClose();
        window.notCheckClients = true;
        window.hasClients = false;
        $('#button-save').click();
    });

    $(document).on('click', '#cancelSave', () => {
        similarClientNotificationClose();
    });
});

const hasSimilarClients = function () {
    const $inputClientAddress = $('input#fias_address');
    const $inputClientName    = $('input#client_name, input#new_client_name');

    if ($inputClientAddress.val().length) {
        $.ajax({
            type: 'POST',
            url: $inputClientName.data('url'),
            async: false,
            data: {
                name: $inputClientName.val(),
                address: $inputClientAddress.val()
            },
            'success': function(data) {
                if (data['success'] == 1) {
                    similarClientNotification(data['clients']);
                    window.hasClients = true;
                } else {
                    similarClientNotificationClose();
                    window.hasClients = false;
                }
            }
        });
    } else {
        similarClientNotificationClose();
        window.hasClients = false;
    }
};

/**
 * Уведомление о наличии похожего заведения при создании нового клиента
 * @param data
 */
var similarClientNotification = function(data) {
      var $content = $similarClientFoundWindow.find('p#content');

      $content.html('');

      $.each(data, function(key, value) {
          $content.append('<a href="' + value['url'] + '" target="_blank" class="open-client-window"><strong>' + value['name'] + '</strong>, ' + value['address'] + ', ' + value['manager'] + '</a><br>');
      });

      $simolarClientFoundWindowOverlay.show();
      $similarClientFoundWindow.center();
      $similarClientFoundWindow.show();
  },
  similarClientNotificationClose = function() {
      $similarClientFoundWindow.hide();
      $simolarClientFoundWindowOverlay.hide();
  },
  $similarClientFoundWindow = $('div#similar-client-found-window'),
  $simolarClientFoundWindowOverlay = $('div#modal-overlay');

function showProUserModal(saveCard) {
    var $proUserHassleModal = $('#pro-user-hassle-manager');
    var $proUserActivityButton = $proUserHassleModal.find('.btn-add-action');
    var $proUserCloseButton = $proUserHassleModal.find('.close-link');
    if ($proUserHassleModal.attr('data-active') === 'true') {

        $proUserHassleModal.dialog({
            width: 660,
            minWidth: 440
        });

        $proUserActivityButton.click(function(event) {
            $proUserHassleModal.dialog('close');
            event.preventDefault();

        });
        $proUserCloseButton.click(function(event) {
            $proUserHassleModal.dialog('close');
            saveCard();
            event.preventDefault();
        });
    }
}